export default __webpack_public_path__ + "static/media/new-payment-icon.59a05411.svg";